import script from "./Summary16167.vue?vue&type=script&setup=true&lang=ts"
export * from "./Summary16167.vue?vue&type=script&setup=true&lang=ts"

import "./Summary16167.vue?vue&type=style&index=0&id=6ebdefe4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ebdefe4"]])

export default __exports__